import { Container, Modal } from 'react-bootstrap';
import { FC } from 'react';
import { typeRole, typeUser } from '@monorepo/models';
import { userRoles } from '@monorepo/helpers';

type propsType = {
    closeModal: () => void;
    users: typeUser[];
};

export const UsersRolesModal: FC<propsType> = ({ closeModal, users }) => {
    return (
        <Modal
            fullscreen={'md-down'}
            onHide={closeModal}
            show
            size={'lg'}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Administradores de la Aplicación
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    {userRoles.map(r =>
                        <Role key={r.number}
                            description={r.description}
                            name={r.name}
                            roleNumber={r.number}
                            users={users}
                        />
                    )}
                </Container>
            </Modal.Body>
        </Modal>
    );
}

type propsType1 = {
    description: string;
    name: string;
    roleNumber: typeRole;
    users: typeUser[];
};

const Role: FC<propsType1> = ({ description, name, roleNumber, users }) => {
    return (
        <div>
            <div className={'bg-secondary text-white p-2 mt-3'}>
                <h5>
                    {name}:
                </h5>
            </div>
            <div className={'ps-1 my-2'}>
                <span className={'fw-bold'}>Descripción:</span> {description}
            </div>
            <div className={'ps-1 fw-bold'}>
                Usuarios:
            </div>
            <div className={'bg-light ps-3'}>
                {users.filter(u => u.roles.includes(roleNumber)).length ?
                    users.filter(u => u.roles.includes(roleNumber)).map(u =>
                        <div key={u.id}>
                            {u.name} {u.lastName} ({u.email})
                        </div>
                    )
                    :
                    '(Ninguno)'
                }
            </div>
        </div>
    );
}
